import { jsonResponseHandling } from '../fetch';
import HTTP_TYPES from '../../types/http-types';
import { apiUrl, PASSENGER_COUNT_PATH, fetchWithSubscriptionKey } from '../api-manager';

const { POST } = HTTP_TYPES;

export const getPassengerCountData = (affectedEntities) => {
    const url = apiUrl(`${PASSENGER_COUNT_PATH}/passenger-count`);
    return fetchWithSubscriptionKey(
        url,
        {
            method: POST,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(affectedEntities),
        },
    ).then(response => jsonResponseHandling(response));
};
